
import React from "react"
import { Grid, Paper, Button, TableRow, TableCell, Table, TableHead, Typography } from "@material-ui/core"
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { panelUsersAuthStyle } from "../../users_auth/panelUsersAuthStyle";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getlistid } from "../../domain/api/EvbiApi"
import TablePagination from '@material-ui/core/TablePagination';
import { ListEvbiAsig } from "../../users_auth/components/modals/ListAsignadas";
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { BiSearch } from "react-icons/bi";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useHistory } from 'react-router-dom';
import theme from "../../../app/config/themaConfig";
import { DeleteEvbi } from "../../domain/api/UsersApi";
import { ModalTowButton } from "../../../utils/modals/modalInfoTowButton";
import { Store } from "react-notifications-component";
const useStyles = makeStyles((theme) => ({
    seeMore: {
        marginTop: theme.spacing(3),
    },
    box: {
        display: "flex",
        marginTop: "2%",
        marginLeft: "70%"
    },
    spreadBox: {
        justifyContent: "space-between",
        alignItems: "center"
    },
    actionsStyles: {
        padding: 0,
        margin: 0
    },
    tableAction: {
        paddingLeft: "2%",
        paddingRight: 0,
        margin: "0 auto",
        textAlign: "center",
        alignItems: "center"
    },
    tableCellWit: {
        maxWidth: '50px'
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    title: {
        marginBottom: '30px',
        marginTop: '30px',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        marginLeft: '0%'
    },
    boxtitle: {
        display: "flex",
        marginTop: "2%",
        marginLeft: "0%",
        paddingLeft: '3%',
        fontSize: '20px'
    },
    TableCell: {
        color: '#0088FE',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        fontSize: '17px',

    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end', // Alinea al final (derecha)
        paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
    },
    searchInputContainer: {
        display: 'flex',
        borderRadius: '20px 0px 0px 20px',
        height: '32px',
        fontSize: '16px',
    },
    searchInput: {
        border: '1px solid  #b6b7b7',
        borderRadius: '20px 0px 0px 20px',
        padding: '4px 8px',
        height: '100%',
        fontSize: 'inherit',
        outline: 'none',
        flex: 1,
    },
    searchButton: {
        color: 'white',
        borderRadius: '0px 50px 50px 0px',
        padding: '8px 16px',
        fontSize: '14px',
    },
}));

export default function EvbisAsignadas(r, lista, props) {
    const location = useLocation();
    const history = useHistory();
    const classes = useStyles();
    const [busqueda, setBusqueda] = useState("")
    const [stateUser, setstateUser] = useState("")


    const clases = panelUsersAuthStyle()
    const [listDate, setlistDate] = useState([])
    const [loading, setLoading] = useState(false)
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = useState(0)
    const [open, setOpen] = useState(false);
    const [isOpenModalDelete, setisOpenModalDelete] = useState(false)


    const [totalElements, setTotalElements] = useState("")
    const rows = r


    //cambio de pagina
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
        init("", id, newPage, rowsPerPage)

    };
    //cambio de tamaño
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        init("", id, 0, event.target.value)
        setPage(0)

    };
    const dispath = useDispatch()
    const filtrar = () => {
        init(busqueda, id, 0, rowsPerPage)
        setPage(0)
    }
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            filtrar();
        }
    };
    const buscador = (e) => {
        setBusqueda(e.target.value, "esta es la busqueda")

    }

    // // variables multi select machine
    const [lisMachine, setlisMachine] = useState([])
    // const [selectMachine, setselectMachine] = useState([])
    const { id } = location.state;
    const { nombre } = location.state;
    const dispatch = useDispatch();

    //listar Evbis
    const init = async (filter, id, page, size) => {

        setLoading(false)
        //lista de evbis por cliente
        const evbis = await getlistid(dispath, filter, id, page, size)


        try {

            setlistDate(evbis.content)
            setTotalElements(evbis.totalElements)
            setLoading(false)
        } catch {
            setlisMachine([])
            setlistDate([])
            setLoading(false)
        }



    }


    useEffect(async () => {


        init("", id, 0, 10)



    }, [])
    const handleDelete = async () => {

        let Request =
        {
            evbi: stateUser.id,
            cliente: 1,
            valor_mensual: 0
        }
        const response = await DeleteEvbi(dispatch, Request)
        try {

            if (response.codigo === '0000') {
                handledAlert("Actualizado Exitosamente!", `Estaciones desasignadas con exito!`, "success")
                setisOpenModalDelete(false)
                init("", id, 0, 10)
            } else {
                handledAlert("Ocurrio un error!", "Ocurrio un error al Asignar las  evbis intente nuevamente", "danger")
            } setisOpenModalDelete(false)

        } catch {
            handledAlert("Ocurrio un erro!", "Error interno", "danger")
        }

    }

    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
        setTimeout(() => {
            // init()
        }, 1000);
    }
    const reload = (e) => {
        init("", id, 0, 10)

    }
    const handledOpenModalDelete = (data) => {
        setstateUser(data)
        setisOpenModalDelete(true)
    }

    const primaryColor = theme.palette.primary.main;

    return (
        <>

            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage="Estaciones Asignadas"
                    to="/"
                    namePage2="Clientes"
                    to2="/Clientes"

                >
                    Home
                </MigaPan>
            </Grid>
            <br></br>


            <Grid item xs={12}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {/* Encabezados de la tabla */}
                        <Box
                            component="span"
                            m={1}
                            className={`${classes.spreadBox} ${classes.boxtitle}`}
                        >
                            <Typography className={classes.title} style={{ fontSize: '25px', fontWeight: 'bold' }} color='primary'>Estaciones asignadas al cliente {nombre} </Typography>
                            <Grid item xs={6} className={classes.searchContainer} >
                                <div className={classes.searchInputContainer}>
                                    <input
                                        id="descripcion"
                                        type="buscador"
                                        name="descripcion"
                                        onChange={buscador}
                                        value={busqueda}
                                        onKeyPress={handleKeyPress}
                                        className={classes.searchInput}
                                        placeholder="Buscar"
                                        style={{
                                            border: `1px solid ${theme.palette.primary.main}`,
                                            borderRadius: '20px 0px 0px 20px',
                                            padding: '4px 8px',
                                            fontSize: 'inherit',
                                            outline: 'none',
                                            flex: 1,
                                        }}
                                    />
                                </div>
                                <Button onClick={filtrar} className={classes.searchButton} style={{ backgroundColor: theme.palette.primary.main }}>
                                    <BiSearch />
                                </Button>
                            </Grid>
                        </Box>

                        <Table>
                            <TableHead color='primary'>
                                <TableRow color='primary'>
                                    <TableCell className={classes.TableCell} style={{ paddingLeft: '3%', width: '14%', color: primaryColor }}>Nombre</TableCell>
                                    <TableCell className={classes.TableCell} style={{ width: '13%', paddingLeft: '0%', color: primaryColor }} >Ubicacion</TableCell>
                                    <TableCell className={classes.TableCell} style={{ width: '20%', paddingLeft: '0%', color: primaryColor }}>Estado </TableCell>
                                    <TableCell className={classes.TableCell} style={{ width: '20%', color: primaryColor }}>Acciones</TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </Grid>
                    <Grid item xs={12}>
                        {/* Componente DatosTablaMantenimiento */}
                        <ListEvbiAsig
                            rows={rows}
                            Asignadas={listDate}
                            classes={clases}
                            totalElement={0}
                            nombreCliente={nombre}
                            // changeStatus={handledOpenModalState}
                            handledOpenModalDelete={handledOpenModalDelete}
                            isLoanding={loading}
                        />
                    </Grid>
                </Grid>
                <Paper className={clases.paper}>




                    <TablePagination
                        component="div"
                        count={totalElements}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage="Datos por página:"
                        style={{ color: primaryColor }}
                    />
                </Paper>
            </Grid>
            {isOpenModalDelete && <ModalTowButton
                setopenMondal={setisOpenModalDelete}
                isOpen={isOpenModalDelete}
                reload={reload}
                title={"Señor usuario"}
                Messange={"¿Esta seguro de desasignar esta Evbi?"}
                handledAccept={handleDelete}


            />}
        </>
    )
}